<template>
  <div class="children-expands-content" :style="{'height': height + 'px'}">
    <div class="model" v-if="loading" v-loading="loading"></div>
    <children-tabs v-if="getShowExpandTable" :default-children='children' :current-row="currentRow" :formRuntimeDialog="formRuntimeDialog" :isExpand="true" />
  </div>
</template>

<script>
import ChildrenTabs from './children-tabs.vue'
import Vue from 'vue'
export default {
  name: 'children-expand',
  props: ['children', 'currentRow', 'formRuntimeDialog', 'height', 'expandParams'],
  provide: {
    childrenExpandEvent: new Vue()
  },
  components: { ChildrenTabs },
  data () {
    return {
      loading: true,
      index: 1
    }
  },
  created () {
    this.index = this.expandParams.count
    this.expandParams.count !== this.expandParams.fixedColumns && this.expandParams.count++
  },
  mounted () {
    this._provided.childrenExpandEvent.$on('report.children.loaded', () => {
      if (this.loading) {
        this.loading = false
      }
    })
  },
  computed: {
    getShowExpandTable () {
      return this.index === 1 && this.expandParams.count === this.expandParams.fixedColumns
    }
  }
}
</script>

<style lang="scss">
  .children-expands-content {
    position: relative;
    min-height: 200px;
    background-color: #fff;
    overflow: auto;
    .model {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 2020;
      background-color: #fff;
    }
    .el-tabs {
      .el-tabs__header {
        margin: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/children-expand.vue